import * as React from 'react';
import { ActionButton } from '../../Button/Action';
import { Stack } from '../../Stack';
import { jsx as _jsx } from "react/jsx-runtime";
export const Suggestions = _ref => {
  let {
    suggestions = [],
    onSelect
  } = _ref;
  return /*#__PURE__*/_jsx(Stack, {
    children: suggestions.map((item, index) => /*#__PURE__*/_jsx(ActionButton, {
      iconProps: {
        iconName: item.type
      },
      onClick: () => onSelect && onSelect(item.value),
      children: item.value
    }, index))
  });
};